const React = require('react')
const { useEffect, useState, useCallback, useRef } = require('react')
const { Row, Col, Container } = require('reactstrap')
const { useBlockchainData, useResponsive, BREAKPOINTS } = require('@hooks')

const { NETWORK_CONFIG } = require('@configs')
const { useNetworkConfig } = require('@contexts')
const { LoadingSpinner } = require('@components')
const { GeneralStatistics } = require('./statistics.general.home')
const { GeneralChart } = require('./chart.general.home')

require('@styles/pages/home/index.css')
require('@styles/pages/home/generalInfo.home/index.css')

const GeneralInfo = () => {
    const { network } = useNetworkConfig()
    const [data, setData] = useState()
    const [loading, setLoading] = useState(true)
    const { getGeneralInfo } = useBlockchainData(network.name)
    const isMobile = useResponsive(BREAKPOINTS.large)

    const isFirstFetch = useRef(true)
    const intervalRef = useRef(null)

    const fetchData = useCallback(async () => {
        try {
            const [infoResponse] = await Promise.all([getGeneralInfo()])
            if (infoResponse) {
                setData(infoResponse)
            }
        } catch (error) {
            console.error('Error fetching network info:', error)
        } finally {
            if (isFirstFetch.current) {
                setLoading(false)
                isFirstFetch.current = false
            }
        }
    }, [network])

    useEffect(() => {
        fetchData()

        intervalRef.current = setInterval(fetchData, NETWORK_CONFIG[network.name].timeInterval)

        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current)
            }
        }
    }, [network, fetchData])

    return (
        <div className='general-info'>
            {loading ? (
                <Container
                    className='box d-flex justify-content-center align-items-center'
                    style={{ minHeight: '180px' }}
                >
                    <LoadingSpinner />
                </Container>
            ) : (
                <Container>
                    <Row style={{ margin: '0' }}>
                        <Col
                            lg='6'
                            style={{
                                borderBottomLeftRadius: '10px',
                                borderTopLeftRadius: '10px',
                                borderBottomRightRadius: isMobile && '10px',
                                borderTopRightRadius: isMobile && '10px'
                            }}
                            className={`box ${!isMobile && 'general-statistics-wrapper'}`}
                        >
                            <Row>
                                <Col sm='6'>
                                    <GeneralStatistics
                                        iconUrl={network.data.averageBlockTimeIcon}
                                        title='Average Block Time'
                                        value={`${network.data.averageBlockTime} seconds`}
                                    />
                                    <GeneralStatistics
                                        iconUrl={network.data.totalActiveAddressesIcon}
                                        title='Total Active Addresses'
                                        value={data?.totalActiveAddresses.toLocaleString()}
                                    />
                                </Col>
                                <Col sm='6'>
                                    <GeneralStatistics
                                        iconUrl={network.data.totalTransactionsIcon}
                                        title='Transactions'
                                        value={data?.totalTransactions.toLocaleString()}
                                    />
                                    <GeneralStatistics
                                        iconUrl={network.data.latestBlockIcon}
                                        title='Last Finalized Block'
                                        value={(data?.latestBlockNumber).toLocaleString()}
                                    />
                                </Col>
                            </Row>
                        </Col>
                        <Col
                            lg='6'
                            className='box'
                            style={{
                                borderBottomLeftRadius: isMobile && '10px',
                                borderTopLeftRadius: isMobile && '10px',
                                borderBottomRightRadius: '10px',
                                borderTopRightRadius: '10px',
                                marginTop: isMobile && '20px'
                            }}
                        >
                            <GeneralChart />
                        </Col>
                    </Row>
                </Container>
            )}
        </div>
    )
}

module.exports = { GeneralInfo }
